if (!customElements.get('hang-rail')) {
  customElements.define('hang-rail', class HangRail extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-hr-data]');
      if (!dataEl) return;
      this.products = JSON.parse(dataEl.textContent);
      this.list = this.querySelector('.hr__list');
      this.dialog = this.querySelector('dialog');
      this.items = Array.from(this.querySelectorAll('.hr__item'));
      this.text = JSON.parse(this.querySelector('[data-hr-text]').textContent);

      this.items.forEach((item) => {
        const btn = item.querySelector('.hr__hit');
        item.addEventListener('mouseenter', () => this.setActive(item));
        item.addEventListener('mouseleave', () => this.setActive(null));
        btn.addEventListener('focus', () => this.setActive(item));
        btn.addEventListener('blur', () => this.setActive(null));
        btn.addEventListener('click', () => { this.trigger = btn; this.open(Number(btn.dataset.index)); });
      });

      if (!this.dialog) return;
      this.el = (sel) => this.dialog.querySelector(sel);
      this.el('[data-hr-close]').addEventListener('click', () => this.dialog.close());
      this.el('[data-hr-prev]').addEventListener('click', () => this.step(-1));
      this.el('[data-hr-next]').addEventListener('click', () => this.step(1));
      this.el('[data-hr-add]').addEventListener('click', () => this.add());
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.target.closest('fieldset')) return;
        if (e.key === 'ArrowLeft') this.step(-1);
        if (e.key === 'ArrowRight') this.step(1);
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        if (this.trigger && !this.skipFocusReturn) this.trigger.focus();
        this.skipFocusReturn = false;
      });
    }

    setActive(item) {
      this.items.forEach((i) => i.classList.toggle('is-active', i === item));
      this.list.classList.toggle('has-active', !!item);
    }

    step(dir) {
      const total = this.products.length;
      this.open((this.index + dir + total) % total);
    }

    open(index) {
      this.index = index;
      const p = this.products[index];
      const pad = (n) => String(n).padStart(2, '0');
      this.el('[data-hr-count]').textContent = `${pad(index + 1)} / ${pad(this.products.length)}`;
      this.el('[data-hr-title]').textContent = p.title;
      const link = this.el('[data-hr-url]');
      link.href = p.url;
      this.el('[data-hr-type]').textContent = p.type || p.title;
      this.el('[data-hr-error]').textContent = '';
      const multi = this.products.length > 1;
      this.el('[data-hr-prev]').hidden = !multi;
      this.el('[data-hr-next]').hidden = !multi;

      this.renderViews(p);
      this.selected = (p.variants.find((v) => v.id === p.selected) || p.variants[0]).options.slice();
      this.renderOptions(p);
      this.updateVariant();

      if (!this.dialog.open) {
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
    }

    renderViews(p) {
      const wrap = this.el('[data-hr-views]');
      const img = this.el('[data-hr-img]');
      wrap.innerHTML = '';
      wrap.hidden = p.views.length < 2;
      const show = (i) => {
        img.src = p.views[i].src;
        img.alt = `${p.title} – ${p.views[i].label}`;
        wrap.querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-pressed', String(i === j)));
      };
      p.views.forEach((v, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'hr-dialog__view';
        b.textContent = v.label;
        b.addEventListener('click', () => show(i));
        wrap.appendChild(b);
      });
      if (p.views.length) show(0);
    }

    renderOptions(p) {
      const wrap = this.el('[data-hr-options]');
      wrap.innerHTML = '';
      if (p.single) return;
      p.options.forEach((opt, oi) => {
        const fs = document.createElement('fieldset');
        fs.className = 'hr-dialog__group';
        const lg = document.createElement('legend');
        lg.textContent = opt.name;
        const vals = document.createElement('div');
        vals.className = 'hr-dialog__values';
        opt.values.forEach((val) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'hr-dialog__value';
          b.textContent = val;
          b.dataset.option = oi;
          b.dataset.value = val;
          b.addEventListener('click', () => { this.selected[oi] = val; this.updateVariant(); });
          vals.appendChild(b);
        });
        fs.append(lg, vals);
        wrap.appendChild(fs);
      });
    }

    updateVariant() {
      const p = this.products[this.index];
      const match = (opts) => p.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      this.variant = match(this.selected);

      this.el('[data-hr-options]').querySelectorAll('.hr-dialog__value').forEach((b) => {
        const oi = Number(b.dataset.option);
        b.setAttribute('aria-pressed', String(this.selected[oi] === b.dataset.value));
        const test = this.selected.slice();
        test[oi] = b.dataset.value;
        const v = match(test);
        b.classList.toggle('is-unavailable', !v || !v.available);
      });

      const v = this.variant;
      const price = this.el('[data-hr-price]');
      price.innerHTML = '';
      const shown = v || p.variants[0];
      price.append(document.createTextNode(shown.price));
      if (shown.compare) {
        const s = document.createElement('s');
        s.textContent = shown.compare;
        price.appendChild(s);
      }

      const add = this.el('[data-hr-add]');
      const ok = !!v && v.available;
      add.disabled = !ok;
      add.textContent = !v ? this.text.unavailable : (ok ? this.text.add : this.text.sold_out);
    }

    add() {
      if (!this.variant) return;
      const btn = this.el('[data-hr-add]');
      const err = this.el('[data-hr-error]');
      btn.setAttribute('aria-busy', 'true');
      err.textContent = '';
      fetch(this.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.variant.id, quantity: 1 }] })
      })
        .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
        .then(({ ok, j }) => {
          if (!ok) { err.textContent = j.description || this.text.error; return; }
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            this.skipFocusReturn = true;
            this.dialog.close();
            drawer.renderContents({});
          } else {
            window.location = this.dataset.cartUrl;
          }
        })
        .catch(() => { err.textContent = this.text.error; })
        .finally(() => btn.removeAttribute('aria-busy'));
    }
  });
}
